import { FC, isValidElement, ReactElement } from 'react';

import { IconName } from '@purpur/library/icon';

import { getPurpurIcon } from '@telialt/common-icon/src/utils';

import { AdaptiveIcon } from '../components/AdaptiveIcon/AdaptiveIcon';
import { AdaptiveImage } from '../components/AdaptiveImage/AdaptiveImage';
import { ORDER_CART_ENTRY_ID, ORDER_CART_TEST_ID } from '../constants';
import { ImageData, Price } from '../model';
import { CellPictogram, CellPrice, CellTitle, ServiceEntryCellDetail, ServiceEntryListItem } from './entries.styles';

type Pictogram = IconName | ImageData | ReactElement | undefined;

const isValidIcon = (pictogram: Pictogram): pictogram is IconName => {
    return typeof pictogram === 'string' && !!getPurpurIcon(pictogram as IconName);
};
const isValidImage = (pictogram: Pictogram): pictogram is ImageData => {
    return pictogram !== null && typeof pictogram === 'object' && 'url' in pictogram && 'alt' in pictogram;
};

export type ServiceEntryProps = {
    icon?: Pictogram;
    name: string;
    mainAllowance?: string;
    description?: string;
    monthlyPrice?: Price;
};

export const ServiceEntry: FC<ServiceEntryProps> = ({ icon, name, monthlyPrice, mainAllowance, description }) => {
    const pictogram =
        (isValidImage(icon) && (
            <AdaptiveImage src={icon.url} alt={icon.alt} {...(!icon.alt && { role: 'presentation' })} />
        )) ||
        (isValidIcon(icon) && <AdaptiveIcon icon={icon} />) ||
        (isValidElement(icon) && icon) ||
        null;

    return (
        <ServiceEntryListItem data-test={ORDER_CART_ENTRY_ID.SERVICE} aria-label={name}>
            {!!pictogram && <CellPictogram>{pictogram}</CellPictogram>}
            <CellTitle data-test={ORDER_CART_TEST_ID.ENTRY_TITLE_SERVICE}>{name}</CellTitle>
            <CellPrice price={monthlyPrice} isMonthly={true} dataTest={ORDER_CART_TEST_ID.PRICE_SERVICE} />
            <ServiceEntryCellDetail>{mainAllowance}</ServiceEntryCellDetail>
            <ServiceEntryCellDetail>{description}</ServiceEntryCellDetail>
        </ServiceEntryListItem>
    );
};
